import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { CREW_MATERIALS_ACTIONS, CREW_MATERIALS_TYPES } from "./actions";
import {
  getCrewMaterial as APIgetCrewMaterial,
  getCrewMaterials as APIgetCrewMaterials,
  createCrewMaterial as APIcreateCrewMaterial,
  updateCrewMaterial as APIupdateCrewMaterial,
  deleteCrewMaterial as APIdeleteCrewMaterial
} from "../../services/api/crewMaterials";
import { navigateTo } from "../navigation/saga";
import { crewMaterialsEvent, crewMaterialsFilters } from "./selectors";

export function* watchCrewMaterialsActions() {
  yield all([
    takeEvery(CREW_MATERIALS_TYPES.LOAD_ALL_REQUEST, getCrewMaterials)
  ]);
  yield all([takeEvery(CREW_MATERIALS_TYPES.LOAD_REQUEST, getCrewMaterial)]);
  yield all([
    takeEvery(CREW_MATERIALS_TYPES.CREATE_REQUEST, createCrewMaterial)
  ]);
  yield all([
    takeEvery(CREW_MATERIALS_TYPES.UPDATE_REQUEST, updateCrewMaterial)
  ]);
  yield all([
    takeEvery(CREW_MATERIALS_TYPES.DELETE_REQUEST, deleteCrewMaterial)
  ]);
  yield all([takeEvery(CREW_MATERIALS_TYPES.CREATE_SUCCESS, getCrewMaterials)]);
  yield all([takeEvery(CREW_MATERIALS_TYPES.DELETE_SUCCESS, getCrewMaterials)]);
}

function* getCrewMaterials(action) {
  let { filters, eventId } = action.payload;

  try {
    if (filters) {
      yield put(CREW_MATERIALS_ACTIONS.updateFilters(filters));
    } else {
      filters = yield select(crewMaterialsFilters);
    }

    eventId = yield call(checkEventId, eventId);

    const crewMaterials = yield call(APIgetCrewMaterials, eventId, filters);
    yield put(CREW_MATERIALS_ACTIONS.loadAllSuccess(crewMaterials));
  } catch (e) {
    yield put(CREW_MATERIALS_ACTIONS.loadAllFailure(e));
  }
}

function* getCrewMaterial(action) {
  let { id, eventId } = action.payload;
  try {
    eventId = yield call(checkEventId, eventId);
    const crewMaterial = yield call(APIgetCrewMaterial, eventId, id);
    yield put(CREW_MATERIALS_ACTIONS.loadSuccess(crewMaterial));
  } catch (e) {
    yield put(CREW_MATERIALS_ACTIONS.loadFailure(e));
  }
}

function* createCrewMaterial(action) {
  let { values, eventId } = action.payload;
  try {
    eventId = yield call(checkEventId, eventId);
    const crewMaterial = yield call(APIcreateCrewMaterial, eventId, values);
    yield put(CREW_MATERIALS_ACTIONS.createSuccess(crewMaterial));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/crew-materials"
    );
  } catch (e) {
    yield put(CREW_MATERIALS_ACTIONS.createFailure(e));
  }
}

function* updateCrewMaterial(action) {
  let { eventId, id, values } = action.payload;
  try {
    eventId = yield call(checkEventId, eventId);
    const crewMaterial = yield call(APIupdateCrewMaterial, eventId, id, values);
    yield put(CREW_MATERIALS_ACTIONS.updateSuccess(crewMaterial));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/crew-materials"
    );
  } catch (e) {
    yield put(CREW_MATERIALS_ACTIONS.updateFailure(e));
  }
}

function* deleteCrewMaterial(action) {
  let { eventId, id } = action.payload;
  try {
    eventId = yield call(checkEventId, eventId);
    const crewMaterial = yield call(APIdeleteCrewMaterial, eventId, id);
    yield put(CREW_MATERIALS_ACTIONS.deleteSuccess(crewMaterial));
    yield call(navigateTo, "/admin/events/" + eventId + "/crew-materials");
  } catch (e) {
    yield put(CREW_MATERIALS_ACTIONS.deleteFailure(e));
  }
}

function* checkEventId(eventId) {
  if (eventId) {
    yield put(CREW_MATERIALS_ACTIONS.updateEvent(eventId));
  } else {
    eventId = yield select(crewMaterialsEvent);
  }

  return eventId;
}
